"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPOTLIGHT_BADGE_CATEGORY_DESCRIPTIONS = exports.SPOTLIGHT_BADGE_CATEGORY_LABELS = exports.DEFAULT_SPOTLIGHT_BADGE_PRIORITY = exports.SPOTLIGHT_BADGE_CATEGORIES = void 0;
exports.parseSpotlightBadgePriority = parseSpotlightBadgePriority;
exports.validateSpotlightBadgePriorityForSave = validateSpotlightBadgePriorityForSave;
exports.resolveSpotlightBadgeCategory = resolveSpotlightBadgeCategory;
/** Which single badge/subtitle a spotlight ticker card shows when a venue matches more than
 * one category at once. Server-computed (SpotlightedVenueDto.badgeCategory) so an admin change
 * takes effect immediately without an app release — mobile just switches on the winning key. */
exports.SPOTLIGHT_BADGE_CATEGORIES = ['sponsored', 'trending', 'activeCheckin', 'activeEvent', 'stickers', 'currentVenue'];
exports.DEFAULT_SPOTLIGHT_BADGE_PRIORITY = [...exports.SPOTLIGHT_BADGE_CATEGORIES];
exports.SPOTLIGHT_BADGE_CATEGORY_LABELS = {
  sponsored: 'Sponsored',
  trending: 'Trending',
  activeCheckin: 'Active check-in',
  activeEvent: 'Active event',
  stickers: 'Stickers',
  currentVenue: 'Current venue'
};
exports.SPOTLIGHT_BADGE_CATEGORY_DESCRIPTIONS = {
  sponsored: 'Venue has an admin-scheduled sponsored period active right now, within the search radius.',
  trending: 'Venue matches a spotlightTrending rule (Popular Today, check-ins per day, or near a hotspot).',
  activeCheckin: 'At least one user is checked in at the venue right now.',
  activeEvent: 'Venue has special/event content active right now (date, time, and day-of-week window).',
  stickers: 'Venue has active (non-expired) stickers posted, and no active check-in or event to show instead.',
  currentVenue: "This is the user's current checked-in venue. Always shown first for that user, whatever its place in this list."
};
function parseSpotlightBadgePriority(raw) {
  if (!Array.isArray(raw)) {
    return [...exports.DEFAULT_SPOTLIGHT_BADGE_PRIORITY];
  }
  const known = new Set(exports.SPOTLIGHT_BADGE_CATEGORIES);
  const seen = new Set();
  const order = [];
  for (const entry of raw) {
    if (typeof entry !== 'string' || !known.has(entry) || seen.has(entry)) {
      continue;
    }
    const key = entry;
    seen.add(key);
    order.push(key);
  }
  for (const key of exports.DEFAULT_SPOTLIGHT_BADGE_PRIORITY) {
    if (!seen.has(key)) {
      order.push(key);
    }
  }
  return order;
}
function validateSpotlightBadgePriorityForSave(value) {
  if (!Array.isArray(value)) {
    return {
      message: 'spotlightBadgePriority must be an array.'
    };
  }
  if (value.length !== exports.SPOTLIGHT_BADGE_CATEGORIES.length) {
    return {
      message: "spotlightBadgePriority must include exactly ".concat(exports.SPOTLIGHT_BADGE_CATEGORIES.length, " entries.")
    };
  }
  const seen = new Set();
  for (let i = 0; i < value.length; i++) {
    const entry = value[i];
    if (typeof entry !== 'string' || !exports.SPOTLIGHT_BADGE_CATEGORIES.includes(entry)) {
      return {
        message: "Invalid spotlight badge category at index ".concat(i, ".")
      };
    }
    if (seen.has(entry)) {
      return {
        message: "Duplicate spotlight badge category \"".concat(entry, "\".")
      };
    }
    seen.add(entry);
  }
  return null;
}
/** Picks the highest-priority category whose flag is true, per admin-configured order. */
function resolveSpotlightBadgeCategory(priority, flags) {
  // The viewer's own checked-in venue always reads "You're here", whatever
  // else it matches; its place in the admin order doesn't matter.
  if (flags.isCurrentVenue) {
    return 'currentVenue';
  }
  const flagByCategory = {
    sponsored: flags.isSponsored,
    trending: flags.isTrending,
    activeCheckin: flags.hasActiveCheckin,
    activeEvent: flags.hasActiveEvent,
    stickers: flags.hasActiveStickers,
    currentVenue: flags.isCurrentVenue
  };
  for (const category of priority) {
    if (flagByCategory[category]) {
      return category;
    }
  }
  return null;
}
//# sourceMappingURL=spotlight-badge-priority.js.map